import type { ScanInterruption } from '../shared/desktop-api';

export const plural = (count: number, one: string, many: string) =>
  `${count.toLocaleString()} ${count === 1 ? one : many}`;

/**
 * What an interrupted scan kept, in words an operator can act on. The count is
 * the authoritative one - complete images counted on disk after the scanner
 * stopped - never a preview tally.
 */
export function keptScanCopy(
  interruption: ScanInterruption | null | undefined,
  keptPages: number,
): { title: string; detail: string | null } {
  const kept = plural(keptPages, 'page', 'pages');
  const excluded =
    interruption && interruption.excludedPages > 0
      ? ` ${plural(interruption.excludedPages, 'unfinished page was', 'unfinished pages were')} left out.`
      : '';
  const check = 'Check the last page before scanning the remaining paper.';
  switch (interruption?.reason) {
    case 'stopped':
      return { title: `Scanning stopped. ${kept} kept.`, detail: `${check}${excluded}` };
    case 'scanner-error':
      return {
        title: `The scanner reported a problem. ${kept} kept.`,
        detail: `${interruption.message ? `${interruption.message} ` : ''}${check}${excluded}`,
      };
    case 'timed-out':
      return {
        title: `The scanner stopped responding. ${kept} kept.`,
        detail: `${check}${excluded}`,
      };
    case 'host-exit':
      return { title: `Scanning ended unexpectedly. ${kept} kept.`, detail: `${check}${excluded}` };
    case 'app-closed':
      return { title: `Paige closed during a scan. ${kept} kept.`, detail: `${check}${excluded}` };
    case 'incomplete-page':
      return { title: `Scanning finished. ${kept} kept.`, detail: `${check}${excluded}` };
    default:
      return { title: `${kept} kept.`, detail: null };
  }
}
